import {inject, Injectable, signal} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CompanyRouteContextService {

  private readonly router = inject(Router);
  readonly currentSiret = signal<string | null>(this.extractSiret(this.router.url));

  constructor() {
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.currentSiret.set(this.extractSiret(this.router.url)));
  }

  private extractSiret(url: string): string | null {
    const match = url.match(/\/dashboard\/company\/(\d{14})(?:\/|$)/);
    return match ? match[1] : null;
  }

  companyBaseSegments(siret: string): string[] {
    return ['/dashboard', 'company', siret];
  }
}
